import type { ComponentProps, ReactNode } from 'react';
import { cn } from './cn';
import { focusRing } from './focus';
import { Tooltip } from './Tooltip';

/** Square icon-only button named by `label`, with a tooltip (label + shortcut); 36 px with a mouse, 44 px on touch (spec §13). */
export function IconButton({
  label,
  icon,
  shortcut,
  pressed,
  size = 'md',
  className,
  type = 'button',
  ...rest
}: Omit<ComponentProps<'button'>, 'children'> & { label: string; icon: ReactNode; shortcut?: string; pressed?: boolean; size?: 'sm' | 'md' }) {
  return (
    <Tooltip label={label} shortcut={shortcut}>
    <button
      type={type}
      aria-label={label}
      aria-pressed={pressed}
      aria-keyshortcuts={shortcut}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full text-fg-muted os-press hover:bg-chrome-hover hover:text-fg disabled:pointer-events-none disabled:opacity-40 aria-pressed:bg-accent-soft aria-pressed:text-fg pointer-coarse:h-11 pointer-coarse:w-11',
        size === 'sm' ? 'h-7 w-7' : 'h-9 w-9',
        focusRing,
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
    </Tooltip>
  );
}
